const resource = '/admin/v1/businesses';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  }
});
